import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, X, Clock, User } from 'lucide-react';
import api from '../utils/api';

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reading, setReading] = useState(null);

  useEffect(() => {
    api.get('/api/blog?published_only=true').then(r => setPosts(r.data)).catch(() => setPosts([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-apex-blue-700 text-white px-4 py-5">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="flex items-center gap-2 text-white/70 text-sm mb-4 hover:text-white"><ArrowLeft className="w-4 h-4" /> Back</Link>
          <h1 className="text-3xl font-black">Tips & Advice</h1>
          <p className="text-white/60 mt-1">Guides from the Apex Towing team</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {loading ? <div className="text-center py-16 text-gray-400">Loading...</div> :
          posts.length === 0 ? (
            <div className="text-center py-16 text-gray-400 bg-white rounded-2xl border border-gray-200">
              <p className="text-4xl mb-3">📝</p>
              <p className="font-bold text-gray-600">Blog coming soon</p>
              <p className="text-sm mt-1">Our team is writing helpful guides for you</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-5">
              {posts.map(p => (
                <button key={p.id} onClick={() => setReading(p)} className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-lg transition-all text-left focus:outline-none">
                  {p.image && <img src={p.image} alt={p.title} className="w-full h-48 object-cover" onError={e => e.target.style.display='none'} />}
                  <div className="p-5">
                    <span className="text-[10px] font-bold text-apex-blue-700 uppercase tracking-wider">{p.category}</span>
                    <h3 className="font-black text-gray-900 mt-1 mb-2 leading-snug text-lg">{p.title}</h3>
                    <p className="text-sm text-gray-500 line-clamp-3">{p.excerpt}</p>
                    <div className="flex items-center gap-3 mt-3 text-xs text-gray-400">
                      <span className="flex items-center gap-1"><User className="w-3 h-3" />{p.author}</span>
                      <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{p.date}</span>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )
        }
      </div>

      {/* Reading modal */}
      {reading && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-end md:items-center justify-center p-0 md:p-4" onClick={e => { if(e.target===e.currentTarget) setReading(null); }}>
          <div className="bg-white rounded-t-2xl md:rounded-2xl w-full md:max-w-2xl max-h-[90vh] flex flex-col shadow-2xl">
            <div className="flex items-center justify-between px-5 py-4 border-b shrink-0">
              <span className="text-xs font-bold text-apex-blue-700 uppercase tracking-wider">{reading.category}</span>
              <button onClick={() => setReading(null)} className="p-1.5 rounded-lg hover:bg-gray-100"><X className="w-5 h-5 text-gray-400" /></button>
            </div>
            <div className="overflow-y-auto flex-1">
              {reading.image && <img src={reading.image} alt={reading.title} className="w-full h-48 object-cover" onError={e => e.target.style.display='none'} />}
              <div className="p-6">
                <h2 className="text-2xl font-black text-gray-900 mb-2">{reading.title}</h2>
                <div className="flex items-center gap-3 mb-4 text-xs text-gray-400">
                  <span className="flex items-center gap-1"><User className="w-3 h-3" />{reading.author}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{reading.date}</span>
                </div>
                {reading.excerpt && <p className="text-gray-600 font-medium mb-4 leading-relaxed text-sm">{reading.excerpt}</p>}
                <div className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">{reading.content || reading.excerpt}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}